import axios from "axios";

const baseURL = `${process.env.REACT_APP_API_URL || "https://api.picprofile.com"}/api/`;
const axiosInstance = axios.create({
  baseURL,
  timeout: 12000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token && token.trim() !== "") {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Queue to hold requests that arrive while a token refresh is in flight
let isRefreshing = false;
let refreshQueue = [];

const processQueue = (error, token = null) => {
  refreshQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve(token);
  });
  refreshQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      // Another refresh is already in flight — queue this request
      return new Promise((resolve, reject) => {
        refreshQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return axiosInstance(originalRequest);
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const refreshToken = localStorage.getItem("refresh_token");

      if (!refreshToken || refreshToken === "undefined" || refreshToken === "null") {
        throw new Error("No refresh token");
      }

      const response = await axios.post(
        `${baseURL}accounts/token/refresh/`,
        { refresh: refreshToken }
      );

      const newAccess = response.data.access;
      const newRefresh = response.data.refresh;

      localStorage.setItem("access_token", newAccess);
      if (newRefresh) localStorage.setItem("refresh_token", newRefresh);

      axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${newAccess}`;
      originalRequest.headers.Authorization = `Bearer ${newAccess}`;

      processQueue(null, newAccess);
      return axiosInstance(originalRequest);

    } catch (refreshError) {
      processQueue(refreshError, null);
      localStorage.clear();
      window.location.href = "/auth";
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default axiosInstance;
